export default __webpack_public_path__ + "static/media/4.Entrenamiento-y-educacion.2029e7a6.png";